import React, { Fragment } from 'react'
import Notification from '@ynap/notification'
import Field from '@ynap/field'
import { RadioButtonWithPrice } from '@ynap/radio-button'
import {CreditCardFormSection} from '@ynap/credit-card-form'
import PaymentCard from '@ynap/payment-card'
import Checkbox from '@ynap/checkbox'
import { getPaymentErrorMessage } from '../utils'
import getCardHolder from '../../../utils/getCardHolder'
import { trackPayPalBASelect } from '../analytics'

export default ({
        selectedCardError,
        newCardError,
        bem,
        messages,
        checkoutError,
        paypalBAEnabled,
        selectedPaymentId,
        deviceType,
        paypalFingerprintToken,
        hideSaveCard,
        klarnaEnabled,
        klarnaPaymentFailed,
        hasPaypalBA,
        cvvRequired,
        applePayEnabled,
        tracking,
        checkoutAnalytics,
    }) =>
    (option) => {
        if (option.cardId) {
            const cardFailed = selectedCardError && option.selected
            const cardHolder = getCardHolder(option.card_holder)

            return option.expired ? (
                <RadioButtonWithPrice
                    key={option.id}
                    disabled
                    label={
                        <>
                            <PaymentCard className={bem('cardType', 'expired')} card={option.type.replace('_', '').toLowerCase()} key={option.type} />
                            <div className={bem('cardInfo')}>
                                {cardHolder && <span className={bem('cardholderName')}>{cardHolder}</span>}
                                <span className={bem('expiredDigits')}>{messages.paymentOptionsForm.expiredCardDigits(option)}</span>
                                <span>{messages.paymentOptionsForm.expiredCardLabel(option)}</span>
                            </div>
                        </>
                    }
                    className={bem('savedCard', { expired: true, default: option.selected })}
                />
            ) : (
                <RadioButtonWithPrice
                    key={option.id}
                    value={option.id}
                    label={
                        <Fragment>
                            {cardFailed ? (
                                <Notification
                                    className={bem('cardFailedNotification')}
                                    type="error"
                                    message={getPaymentErrorMessage(checkoutError, messages)}
                                />
                            ) : null}
                            <PaymentCard className={bem('cardType')} card={option.type.replace('_', '').toLowerCase()} key={option.type} />
                            <div className={bem('cardInfo')}>
                                {cardHolder && <span className={bem('cardholderName')}>{cardHolder}</span>}
                                <span>{messages.paymentOptionsForm.savedCardLabel(option)}</span>
                            </div>
                        </Fragment>
                    }
                    className={bem('savedCard', { cardFailed, default: option.selected })}
                >
                    {({ checked }) =>
                        checked &&
                        cvvRequired && (
                            <CreditCardFormSection name="creditCard" messages={messages} hideSaveCard={hideSaveCard} className={bem('cardform')} showCvvOnly />
                        )
                    }
                </RadioButtonWithPrice>
            )
        }

        if (paypalBAEnabled && (!deviceType || (deviceType && paypalFingerprintToken)) && option.billingAgreementToken) {
            return (
                <RadioButtonWithPrice
                    key={option.id}
                    value={option.id}
                    label={
                        <Fragment>
                            <PaymentCard className={bem('cardType')} card={'paypalshort'} key={option.id} />
                            <span>{option.billingAgreementEmail}</span>
                        </Fragment>
                    }
                    className={bem('paypal-ba', { default: option.selected })}
                />
            )
        }

        switch (option.id) {
            case 'CREDIT_CARD':
                return (
                    <RadioButtonWithPrice
                        key={option.id}
                        value={option.id}
                        label={
                            <Fragment>
                                {newCardError && (
                                    <Notification
                                        type="error"
                                        className={bem('cardFailedNotification')}
                                        message={getPaymentErrorMessage(checkoutError, messages)}
                                    />
                                )}
                                <div className={bem('allCardTypes')}>
                                    {option.types.map((type) => (
                                        <PaymentCard className={bem('cardType')} card={type.replace('_', '').toLowerCase()} key={type} />
                                    ))}
                                </div>
                            </Fragment>
                        }
                        className={bem('tender-creditcard', { default: option.selected })}
                        price={option.price}
                    >
                        {({ checked }) =>
                            checked ? (
                                <CreditCardFormSection
                                    name="creditCard"
                                    messages={messages}
                                    hideSaveCard={hideSaveCard}
                                    className={bem('cardform')}
                                ></CreditCardFormSection>
                            ) : null
                        }
                    </RadioButtonWithPrice>
                )
            case 'PAYPAL':
                return (
                    <RadioButtonWithPrice
                        key={option.id}
                        value={option.id}
                        label={messages.paymentOptionsForm.payPal()}
                        className={bem('tender-paypal', { default: option.selected })}
                        price={option.price}
                    >
                        {({ checked }) => (
                            <>
                                <div className={bem('paypal-credit', klarnaEnabled && 'klarna')} />
                                {checked ? (
                                    <div className={bem('paypal-info-wrapper')}>
                                        <div className={bem('paypal-info')}>{messages.paymentOptionsForm.payPalHelp()}</div>
                                        {paypalBAEnabled && !hasPaypalBA && !hideSaveCard ? (
                                            <Field
                                                component={Checkbox}
                                                className={bem('paypal-save')}
                                                name="savePayment"
                                                format={(value) => value === 'true'}
                                                normalize={(value) => value.toString()}
                                                onClick={(e) => tracking.trackEvent(trackPayPalBASelect(e.target?.checked, checkoutAnalytics))}
                                            >
                                                {messages.paymentOptionsForm.payPalBA()}
                                            </Field>
                                        ) : null}
                                    </div>
                                ) : null}
                            </>
                        )}
                    </RadioButtonWithPrice>
                )
            case 'APPLEPAY':
                return (
                    applePayEnabled && (
                        <RadioButtonWithPrice
                            key={option.id}
                            value={option.id}
                            label={messages.paymentOptionsForm.applePay()}
                            className={bem('tender-applepay', { default: option.selected })}
                            price={option.price}
                        />
                    )
                )
            case klarnaEnabled && /^KLARNA\w*$/.test(option.id) && option.id:
                return (
                    <RadioButtonWithPrice
                        key={option.id}
                        value={option.id}
                        label={
                            <Fragment>
                                {klarnaPaymentFailed && option.id === selectedPaymentId && (
                                    <Notification
                                        type="error"
                                        className={bem('cardFailedNotification')}
                                        message={getPaymentErrorMessage(checkoutError, messages)}
                                    />
                                )}
                                <div className={bem('klarna-label')}>{messages.paymentOptionsForm?.klarnaOptions({ type: option.id })}</div>
                            </Fragment>
                        }
                        className={bem('tender-klarna', [
                            option.id.replace('KLARNA_', '').replace(/[_]+/g, '-').toLocaleLowerCase(),
                            option.selected && 'default',
                        ])}
                        price={option.price}
                    >
                        {({ checked }) =>
                            checked ? (
                                <div className={bem('klarna-info')}>
                                    <div className={bem('klarna-info-header')}>{messages.paymentOptionsForm?.klarnaHelpHeader({ type: option.id })}</div>
                                    <div className={bem('klarna-info-copy', 'ref')}>
                                        {messages.paymentOptionsForm?.klarnaHelpReference({ type: option.id })}
                                    </div>
                                    <div className={bem('klarna-info-copy')}>{messages.paymentOptionsForm?.klarnaHelpInfo({ type: option.id })}</div>
                                </div>
                            ) : null
                        }
                    </RadioButtonWithPrice>
                )
            case 'AFFIRM':
                return (
                    <RadioButtonWithPrice
                        key={option.id}
                        value={option.id}
                        label={<div className={bem('affirm-label')}>{messages.paymentOptionsForm?.affirmOptions({ type: option.id })}</div>}
                        className={bem('tender-affirm', { default: option.selected })}
                        price={option.price}
                    ></RadioButtonWithPrice>
                )
            case 'COD':
                return (
                    <RadioButtonWithPrice
                        key={option.id}
                        value={option.id}
                        label={messages.paymentOptionsForm.cashOnDelivery()}
                        className={bem('tender-cod', option.selected && 'default')}
                        finalShippingPrice={option.price}
                    >
                        {({ checked }) =>
                            checked ? <Notification className={bem('cod-info')} type="info" message={messages.paymentOptionsForm.cashOnDeliveryHelp()} /> : null
                        }
                    </RadioButtonWithPrice>
                )
        }
    }
